import { render } from "./PcsmsLogin.vue?vue&type=template&id=cd964354&scoped=true"
import script from "./PcsmsLogin.vue?vue&type=script&lang=js"
export * from "./PcsmsLogin.vue?vue&type=script&lang=js"

import "./PcsmsLogin.vue?vue&type=style&index=0&id=cd964354&scoped=true&lang=less"

import exportComponent from "C:\\Users\\PC\\AppData\\Local\\Temp\\tecs-enduser-release-cd96384e-20260902-1753\\TECS-FE-ENDUSER-NEW\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd964354"]])

export default __exports__